interface IconProps {
  color?: string;
  className?: string;
}

export default function SosIcon({
  color = "#8E929E",
  className = "",
}: IconProps) {
  return (
    <svg
      width="26"
      height="16"
      viewBox="0 0 26 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.47 0C5.71 0 6.86 1.34 6.86 3.69V4.15H4.68V3.54C4.68 2.49 4.26 2.09 3.53 2.09C2.8 2.09 2.38 2.49 2.38 3.54C2.38 6.56 6.88 7.12 6.88 11.31C6.88 13.66 5.71 15 3.44 15C1.17 15 0 13.66 0 11.31V10.41H2.18V11.46C2.18 12.51 2.64 12.88 3.37 12.88C4.1 12.88 4.56 12.5 4.56 11.46C4.58 8.44 0.07 7.88 0.07 3.69C0.07 1.34 1.22 0 3.47 0Z"
        fill={color}
      />
      <path
        d="M9.12002 12.6099V14.8299H6.90002V12.6099H9.12002Z"
        fill={color}
      />
      <path
        d="M9.20001 3.69C9.20001 1.34 10.44 0 12.7 0C14.96 0 16.2 1.34 16.2 3.69V11.32C16.2 13.67 14.96 15.01 12.7 15.01C10.44 15.01 9.20001 13.67 9.20001 11.32V3.69ZM11.51 11.46C11.51 12.51 11.97 12.91 12.71 12.91C13.45 12.91 13.9 12.51 13.9 11.46V3.54C13.9 2.49 13.44 2.09 12.71 2.09C11.98 2.09 11.51 2.49 11.51 3.54V11.46Z"
        fill={color}
      />
      <path d="M18.51 12.6099V14.8299H16.29V12.6099H18.51Z" fill={color} />
      <path
        d="M21.98 0C24.22 0 25.37 1.34 25.37 3.69V4.15H23.19V3.54C23.19 2.49 22.77 2.09 22.04 2.09C21.31 2.09 20.89 2.49 20.89 3.54C20.89 6.56 25.39 7.12 25.39 11.31C25.39 13.66 24.22 15 21.95 15C19.68 15 18.51 13.66 18.51 11.31V10.41H20.69V11.46C20.69 12.51 21.15 12.88 21.88 12.88C22.61 12.88 23.07 12.5 23.07 11.46C23.07 8.44 18.57 7.88 18.57 3.69C18.57 1.34 19.72 0 21.96 0L21.98 0Z"
        fill={color}
      />
    </svg>
  );
}
